module.exports = __webpack_public_path__ + "img/GAB.4348b597.svg";